export default __webpack_public_path__ + "static/media/architecture-img-20.04cd94cf.jpg";